import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { navigationEvent } from 'services/dataLayerService';
import Dropdown from '../Dropdown';
import SimpleMenu from '../SimpleMenu';
import ResourcesMenu from '../ResourcesMenu';
import SolutionsMenu from '../SolutionsMenu';
import ProductsMenu from '../ProductsMenu';

import MenuItemContainer from './styles';
import BusinessMenu from '../BusinessMenu';
import useIsClient from 'hooks/useIsClient';
import { twMerge } from 'tailwind-merge';

const MenuItem = ({ className, type, menu }) => {
  let DropdownComponent;
  const dropdownItems = menu.subNavigationElement;
  const isClient = useIsClient();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  if (type === 'simple') {
    DropdownComponent = SimpleMenu;
  } else if (type === 'resources') {
    DropdownComponent = ResourcesMenu;
  } else if (type === 'solutions') {
    DropdownComponent = SolutionsMenu;
  } else if (type === 'products') {
    DropdownComponent = ProductsMenu;
  } else if (type === 'commercial' || type === 'residential') {
    DropdownComponent = BusinessMenu;
  }

  useEffect(() => {
    const resizeHandler = () => {
      const menuItem = document.querySelector(`#${type}-menu-container`);
      const menuDropdownContainer = document.querySelector(`.${type}-menu-modal`);

      if (menuItem && menuDropdownContainer) {
        const viewportWidth = document.documentElement.clientWidth;
        const menuItemRect = menuItem.getBoundingClientRect();
        const menuDropdownRect = menuDropdownContainer.getBoundingClientRect();

        if (menuDropdownRect.width > viewportWidth / 2) {
          menuDropdownContainer.style.left = `${
            ['products', 'commercial'].includes(type)
              ? menuDropdownRect.width / 3
              : viewportWidth / 2 - menuItemRect.left
          }px`;
          const menuDropdownTopArrow = document.querySelector(
            `.${type}-menu-modal .header-menu-arrow`,
          );
          if (menuDropdownTopArrow) {
            menuDropdownTopArrow.style.left = `${
              (['products', 'commercial'].includes(type)
                ? menuItemRect.width / 2 - menuDropdownRect.width / 3
                : -viewportWidth / 2 + menuItemRect.left + menuItemRect.width / 2) - 11
            }px`;
          }
        }
      }
    };

    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
  }, [menu]);

  return (
    <MenuItemContainer
      id={`${type}-menu-container`}
      className="menu-item-container"
      onMouseLeave={() => setDropdownOpen(false)}
      onMouseEnter={() => setDropdownOpen(true)}
    >
      <Button
        className={twMerge('h-3/4', !isClient && 'blur-[3px]')}
        onClick={() => {
          menu.url && navigate(menu.url);
          navigationEvent(menu?.label, menu?.url);
        }}
        onMouseEnter={() => setDropdownOpen(true)}
      >
        <p>{menu.label}</p>
        {dropdownItems && (dropdownOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />)}
      </Button>
      {dropdownItems && (
        <Dropdown open={dropdownOpen} className={className}>
          <DropdownComponent
            menu={menu}
            dropdownItems={dropdownItems}
            handleFocus={(id, event) => event?.target?.setAttribute('autocomplete', 'off')}
          />
        </Dropdown>
      )}
    </MenuItemContainer>
  );
};

export default MenuItem;
